import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useRef } from 'react';
import { ComposerInput } from '../ComposerInput';
import { ChatThread } from './ChatThread';
/**
 * Compact chat sidebar for fullscreen artifact editing
 * Shows messages and composer in a narrow sidebar
 */ export const CompactChatSidebar = /*#__PURE__*/ memo(function CompactChatSidebar({ messages, isSending, chatId, onSubmit, onFeedback, onStop, readOnly = false }) {
    const scrollContainerRef = useRef(null);
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-96 border-r border-border flex flex-col h-full bg-background",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "border-b border-border px-4 h-12 flex items-center flex-shrink-0",
                children: /*#__PURE__*/ _jsx("h2", {
                    className: "text-sm font-medium text-foreground",
                    children: "Chat"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: scrollContainerRef,
                className: "flex-1 overflow-y-auto overflow-x-hidden px-4 py-6",
                children: /*#__PURE__*/ _jsx(ChatThread, {
                    messages: messages,
                    isSending: isSending,
                    chatId: chatId,
                    onFeedback: onFeedback,
                    readOnly: readOnly
                })
            }),
            !readOnly && /*#__PURE__*/ _jsx("div", {
                className: "border-t border-border px-4 py-4 flex-shrink-0",
                children: /*#__PURE__*/ _jsx(ComposerInput, {
                    onSubmit: onSubmit,
                    onStop: onStop,
                    submitting: isSending,
                    mode: "chat",
                    submitLabel: "Send"
                })
            })
        ]
    });
});
